import { createSelector } from "reselect";
import { makeSelectAllUserAnswers } from "../userAnswers/selectors";
import { makeSelectAllUsers } from "../user/selectors";
import { createMakeSelectCurrentPage } from "../../lib/providers/pagination-provider/selectors";
import { makeSelectQuestionnaires } from "../questionnaires/selectors";
import { makeSelectQuestionnaireCategory } from "../questionnaireCategories/selectors";
import { makeSelectEntityStatuses } from "../entity_status";

const selectEntity = state => state.entities.questionnaire_answer;
const selectEntityData = state =>
  state.entities.questionnaire_answer
    ? state.entities.questionnaire_answer.data
    : [];
const selectAuth = state => state.global.auth;
const selectForm = state => state.form;

/*
export const makeSelectQuestionnaireAnswer2 = () =>
  createSelector([selectEntityData], (substate) => substate);
*/

export const makeSelectQuestionnaireAnswer = paginationKey =>
  createSelector(
    [
      selectEntityData,
      createMakeSelectCurrentPage(paginationKey)(),
      makeSelectAllUsers(),
      makeSelectQuestionnaires(),
      makeSelectEntityStatuses()
    ],
    (substate, page, users, questionnaires, entityStatus) => {
      if (!paginationKey) {
        return { ...substate };
      }

      if (page.length > 0)
        return page
          .map(id => {
            if (!substate[id]) {
              return null;
            }
            const questionnaireAnswer = { ...substate[id] };

            questionnaireAnswer.questionnaire =
              questionnaires[questionnaireAnswer.questionnaire.id];
            questionnaireAnswer.user = users[questionnaireAnswer.user.id];
            if (questionnaireAnswer.user.entity_status) {
              questionnaireAnswer.user.entity_status =
                entityStatus[questionnaireAnswer.user.entity_status.id];
            }
            return questionnaireAnswer;
          })
          .filter(row => row);

      return [];
    }
  );

export const makeSelectOneQuestionnaireAnswer = id =>
  createSelector(
    [
      selectEntityData,
      makeSelectAllUserAnswers(),
      makeSelectQuestionnaires(),
      makeSelectQuestionnaireCategory()
    ],
    (substate, answers, questionnaires, categories) => {
      if (!substate) {
        return {};
      }
      const questionnaireAnswer = substate[id];
      if (!questionnaireAnswer) {
        return {};
      }
      const newAnswers = [];

      //questionnaireAnswer.current_category = categories[questionnaireAnswer.current_category.id];
      questionnaireAnswer.questionnaire =
        questionnaires[questionnaireAnswer.questionnaire.id];
      if (
        questionnaireAnswer.answers &&
        questionnaireAnswer.answers.length > 0
      ) {
        for (let answer of questionnaireAnswer.answers) {
          //delete answers[answer.id].id;
          delete answers[answer.id].created_at;
          delete answers[answer.id].updated_at;
          newAnswers.push(answers[answer.id]);
        }
        questionnaireAnswer.answers = newAnswers;
      }

      return questionnaireAnswer;
    }
  );

export const makeSelectUserToken = () =>
  createSelector([selectAuth], substate => substate.token);

export const makeSelectUserAuth = () =>
  createSelector([selectAuth], substate => substate);

export const makeSelectReduxFormQuestionnaire = () =>
  createSelector([selectForm], substate => substate);

export const makeSelectQuestionnaireAnswerLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
  });
